import { requst } from '../config'

export const postSaudiAramcoApi = (params, file) => {
    const url = `/shate/excel/upload`
    const formData = new FormData()
    formData.append('file', file)
    return requst({
        url,
        method: 'post',
        params,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
        data: formData,
    })
}

export const getSaudiAramcoListApi = params => {
    let url,
        query = ''
    const paramsList = Object.keys(params)
    paramsList.forEach(item => (query += `&${item}=${params[item]}`))
    const result = query.slice(1)
    url = `/shate/excel/page?` + result
    return requst.get(url)
}

export const getSaudiAramcoFinalApi = projectId => {
    const url = `/shate/excel/final/${projectId}`
    return requst.get(url)
}

export const downloadSaudiAramcoIdApi = id => {
    const url = `/shate/excel/download/${id}`
    return requst.get(url, {
        responseType: 'blob',
    })
}

export const getSaudiAramcoDeleteApi = id => {
    const url = `/shate/excel/${id}`
    return requst.delete(url)
}
